// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__siiiQ","additionalInfo":"AgreementModal_additionalInfo__2e5R6"};